import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  promoCodes: null,
  loading: false,
  saved: false,
};

function onLoadPromoCodesSuccess(state, { payload }) {
  const { data, filteredCount, totalCount } = payload;
  const promoCodes = data;

  return {
    ...state,
    promoCodes,
    filteredCount,
    totalCount,
    loading: false,
  };
}

function onAddPromoCode(state) {
  return {
    ...state,
    loading: true,
  };
}

function onSaveSuccess(state) {
  return {
    ...state,
    saved: true,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_PROMOCODES_SUCCESS]: onLoadPromoCodesSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.ADD_PROMOCODE]: onAddPromoCode,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
});
